import { render, staticRenderFns } from "./OwnerNoticeView.vue?vue&type=template&id=3264f105&"
import script from "./OwnerNoticeView.vue?vue&type=script&lang=js&"
export * from "./OwnerNoticeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports